import { AxiosResponse } from "axios";

export function handleResponse(resp: AxiosResponse<any>) {
    if (!resp.data) {
      throw new Error('error, please refresh or contact support')
    }

    return resp.data
}